
import missionImg from '../assets/goal_1535019.png'
import targetImg from '../assets/target_610064.png'
import vision from '../assets/target_610246.png'


const VisionMissionGoalComponent = () => {

    return (

        <div className=' lg:w-[80%] lg:m-auto md:w-[90%] md:m-auto sm:w-[100%]sm:m-0 px-2 py-2 my-4'>
            <section className="animate__animated animate__backInLeft animate__delay-1s flex justify-center items-center gap-4 lg:flex-row md:flex-row flex-wrap sm:flex-col bg-white ">

                <div className="px-2 py-2.5  lg:w-[300px] md:w-[100%] sm:w-[100%] ">
                    <div className='flex justify-center align-middle'>
                        <img
                            src={`${missionImg}`}
                            alt="our mission"
                            className='w-[100px] h-[100px] object-cover items-center '
                        />
                    </div>
                    <h1 className='font-bold text-[22px] text-center py-2 capitalize'>Énoncé de Mission</h1>
                    <div className='text-center lg:px-6 md:px-4 sm:px-2 py-2'>
                        Promouvoir l'éducation, le leadership
                        personnel et l'autonomie pour les jeunes en
                        Haıẗi.
                    </div>
                </div>



                <div className=" px-2 py-2.5 lg:w-[300px] md:w-[100%] sm:w-[100%] ">
                    <div className='flex justify-center align-middle'>
                        <img
                            src={`${targetImg}`}
                            alt="our mission"
                            className='w-[100px] h-[100px] object-cover align-middle'

                        />
                    </div>
                    <h1 className='font-bold text-[22px] text-center py-2'>Notre vision</h1>
                    <div className='text-center px-2 py-2'>
                        Créer le développement en se basant sur
                        l'éducation et se centrant sur la jeunesse.
                    </div>
                </div>


                <div className="px-2 py-2.5 lg:w-[300px] md:w-[100%] sm:w-[100%] ">
                    <div className='flex justify-center align-middle'>
                        <img
                            src={`${vision}`}
                            alt="our mission"
                            className='w-[100px] h-[100px] object-cover align-middle'
                        />
                    </div>
                    <h1 className='font-bold text-[22px] text-center py-2'>Notre But</h1>
                    <div className='text-center px-2 py-2'>
                        Aider chaque enfants et jeune en Haıẗi à réussir,
                         tout en leur aidant à avoir une bonne bonne éducation.
                    </div>
                </div>

            </section>

        </div>
    )
}


export default VisionMissionGoalComponent